var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editingAllowed)?_c('button',{staticClass:"edit-button",on:{"click":function($event){return _vm.showEditor(_vm.type, _vm.context)}}},[_c('svgicon',{attrs:{"color":"white","height":"15","icon":"pencil","width":"15"}}),(_vm.textLabel)?_c('span',[_vm._v(_vm._s(_vm.textLabel))]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }